import fallbackImage from '@/assets/images/seo-fallback.jpg'
import i18n from '@/i18n/index.js'

export const setMeta = (seo) => {
  const title = seo.title ? `${seo.title}` : i18n.global.t('seo.fallback.title')

  document.title = title
  const metas = document.getElementsByTagName('meta')
  metas['keywords'].content = seo.keywords || i18n.global.t('seo.fallback.keywords')
  metas['og:title'].content = title
  metas['description'].content = seo.description || i18n.global.t('seo.fallback.description')
  metas['og:description'].content = seo.description || i18n.global.t('seo.fallback.description')
  metas['og:image'].content = seo.image?.original || fallbackImage
  metas['og:type'].content = seo.type || 'website'
  metas['og:url'].content = seo.url || import.meta.env.BASE_URL
}
